import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { SOFTLINE_PERMISSION_ESL } from '@softapps/handel/esl-link';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import {
  eslLinkRoutes,
  eslLinkStorageRoutes,
  eslSearchRoutes,
} from './esl-link-storage.routes';
import { SOFTLINE_PERMISSION_ESL_STORAGE } from './esl-link-storage.shared';
import { getModuleGroupByName } from '@softline/application';

export function provideEslLinkStorageProviders(config?: { storageSelection: boolean }) {
  if (config?.storageSelection && config?.storageSelection === true) {
    return [
      provideSoftAppsModule(
        {
          name: 'esl-link-storage',
          title: '#ESL.STORAGE_APP_TITLE',
          icon: 'fa-regular fa-tags',
          route: '/esl-link-storage/selection',
          permission: SOFTLINE_PERMISSION_ESL_STORAGE,
          group: getModuleGroupByName('Elektronische Etiketten'),
        },
        withSoftAppsModuleTranslation({ de, en }),
        withSoftAppsModuleRoutes({
          app: eslLinkStorageRoutes,
        }),
        withSoftAppsModuleInfo({
          library: '@softapps/handel/esl-link-storage',
          description:
            'Elektronische Etiketten mit Artikeln verknüpfen, mit Lagerauswahl.',
        })
      ),
    ];
  } else {
    return [
      provideSoftAppsModule(
        {
          name: 'esl-link-new',
          title: '#ESL.APP_TITLE',
          icon: 'fa-regular fa-tags',
          route: '/esl-link/associate',
          permission: SOFTLINE_PERMISSION_ESL,
          group: getModuleGroupByName('Elektronische Etiketten'),
        },
        withSoftAppsModuleTranslation({ de, en }),
        withSoftAppsModuleRoutes({
          app: eslLinkRoutes,
        }),
        withSoftAppsModuleInfo({
          library: '@softapps/handel/esl-link-storage',
          description: 'Elektronische Etiketten mit Artikeln verknüpfen.',
        })
      ),
    ];
  }
}

export const provideEslSearchProviders = () => {
  return provideSoftAppsModule(
    {
      name: 'esl-search',
      title: 'ESL Suche',
      icon: 'fa-solid fa-magnifying-glass',
      route: '/esl-search/flash',
      permission: SOFTLINE_PERMISSION_ESL,
      group: getModuleGroupByName('Elektronische Etiketten'),
    },
    withSoftAppsModuleTranslation({ de, en }),
    withSoftAppsModuleRoutes({
      app: eslSearchRoutes,
    }),
    withSoftAppsModuleInfo({
      library: '@softapps/handel/esl-link-storage',
      description: 'Elektronische Etiketten suchen und aufblinken lassen.',
    })
  );
};
